<p-breadcrumb class="customBreadcrumb" (onItemClick)="itemClicked($event.item)" [model]="menuItems"></p-breadcrumb>
